module.exports = __webpack_public_path__ + "img/568212c.png";